export default __webpack_public_path__ + "9c7da9d6395d4842f0bb9d5309b8fd84.svg";